/**
 * Pulls a human-readable message out of a failed API call.
 *
 * The backend returns plain-text/JSON-string bodies for validation
 * failures (e.g. `return Conflict("Cannot delete a location that has
 * children.")`), which most HTTP clients surface as a bare string rather
 * than a `{ message: string }` object — so this checks both shapes before
 * falling back to a generic message.
 */
export function getApiErrorMessage(e: any, fallback: string): string {
    const data = e?.response?.data;
    if (typeof data === "string" && data.trim()) return data;
    if (data && typeof data.message === "string" && data.message.trim()) return data.message;

    if (typeof e?.data === "string" && e.data.trim()) return e.data;
    if (typeof e?.body === "string" && e.body.trim()) return e.body;

    if (typeof e?.message === "string" && e.message.trim()) return e.message;

    return fallback;
}
